export const routeTitles = {
  "/": "Home",
  "/clients": "Clients",
  "/projects": "Projects",
  "/tasks": "Tasks",
  "/messages": "Messages",
  "/finance": "Finance",
  "/requests": "Requests",
  "/reports": "Reports",
  "/create-user": "Create User",
  "/settings": "Settings",
  "/users": "Users",
  "/brief": "Brief",
  "/careers-admin": "Job Postings",
  "/careers-applications": "Job Applications",
};